<template>
  <pre v-if="html" class="json" aria-label="Preference JSON"><code v-html="html" /></pre>
  <pre v-else class="json fallback"><code>{{ code }}</code></pre>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({ code: { type: String, default: '' } })

function highlight(code) {
  const pretty = JSON.stringify(JSON.parse(code), null, 2)
  const escaped = pretty
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
  return escaped.replace(
    /("(?:\\u[a-fA-F0-9]{4}|\\[^u]|[^\\"])*")(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g,
    (match, str, colon, literal) => {
      if (str) {
        return colon
          ? `<span class="key">${str}</span>${colon}`
          : `<span class="string">${str}</span>`
      }
      if (literal) return `<span class="literal">${literal}</span>`
      return `<span class="number">${match}</span>`
    },
  )
}

const html = computed(() => {
  try {
    return highlight(props.code)
  } catch {
    return ''
  }
})
</script>

<style scoped>
.json {
  margin: 1rem 0;
  padding: 1rem 1.15rem;
  border: 1px solid var(--border);
  border-left: 4px solid #216653;
  border-radius: 10px;
  background: #f4f8f6;
  color: #3d4a55;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 0.92rem;
  line-height: 1.6;
  overflow: auto;
  white-space: pre;
}
.json :deep(.key) { color: #1e3a8a; font-weight: 650; }
.json :deep(.string) { color: #216653; }
.json :deep(.number) { color: #9a3412; }
.json :deep(.literal) { color: #7c3aed; }
</style>
